// extracted by mini-css-extract-plugin
export default {"editor":"Editor_editor__XgdMD","dragOverlayContent":"Editor_dragOverlayContent__xCgL3","editorWrapper":"Editor_editorWrapper__udWHW","sortable":"Editor_sortable__I-b0a"};